import { createContext, useContext } from 'react'

// Lets a page (the Today ask bar) open the AI sidebar prefilled with text and submit
// it. The chat has no global store, so AppLayout owns the open state and provides this
// launcher; consumers call openChatWith(prompt). A no-op default keeps it safe outside
// the provider (e.g. isolated component tests).
export type ChatLauncher = (prompt: string) => void

const ChatLauncherContext = createContext<ChatLauncher>(() => {})

export const ChatLauncherProvider = ChatLauncherContext.Provider

export function useChatLauncher(): ChatLauncher {
  return useContext(ChatLauncherContext)
}
